import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { CssClassMapping } from 'src/app/core/configuration/css-class-mapping';

@Component({
  selector: 'app-protocol-document-selection',
  templateUrl: './protocol-document-selection.component.html',
  styleUrls: ['./protocol-document-selection.component.css']
})
export class ProtocolDocumentSelectionComponent implements OnInit {

  documentList: DocumentoAllegato[] = [];
  selectedDocs: DocumentoAllegato[] = [];
  searchText = null;
  // @ViewChild('searchText') searchText!: ElementRef;
  constructor(
    private dialogConfig : DialogConfig,
    private dialogRef : DialogRef
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      const filteredDocuments = this.dialogConfig.data.documents.filter(element => element.numeroProtocollo === null);
      filteredDocuments.forEach(element => {
        element['descrizione'] = element.tipoDocumento.descrizione;
        element['primary'] = false; // Imposta primary a false
      });
      this.documentList = filteredDocuments;
      console.log('this.documentList',this.documentList)
      
    });
  }

  onProceed(event) {
    this.dialogRef.close({modalEvent : event, selectedDocuments: this.selectedDocs});
  }

  getIconByContentType(id: string) {
    return CssClassMapping.cssIconDocumentazioneAllegata[id];
  }

  onReset(event) {
    this.dialogRef.close({modalEvent : event});
  }

  onSearch() {}

  onSearchChange(event) {
    // let filtered = this.documentList.filter(
    //   el => el.titolo.toLowerCase().includes(event) || el.posizione.toLowerCase().includes(event) || el.tipoDocumento.descrizione.toLowerCase().includes(event)
    // )
    // this.documentList = [...filtered];
    // console.log(filtered, 'filtered')
  }

  onSelectDoc(event, doc: DocumentoAllegato) {
    let index = this.selectedDocs.findIndex(itm => itm.id === doc.id);
    if(event.target.checked && index === -1) {
      this.selectedDocs.push(doc);
    } else {
      this.selectedDocs.splice(index, 1);
    }
  }
}
